import { UnitUsageRange } from "@asd/customer-portal-api";
import { darken, lighten, PaletteOptions } from "@mui/material/styles";

import { OrganizationKey } from "../utils/orgConfig";
import { OverrideSelectors, UnitUsageSelectors } from "./baseTheme";

const COLORS = {
  BLACK: "#009000",
  GRAY: "#C1C1C1",
  LIGHT_GRAY: "#E8E8E8",
  BLUE: "#0F398B",
  POWDER_BLUE: "#758DBE",
  LIGHT_BLUE: "#D6E7FF",
  GOLD: "#BF9000",
  ORANGE: "#E95624",
  PAS_ORANGE: "#F14E29",
};

export const LKC_COLORS: PaletteOptions = {
  primary: {
    main: COLORS.POWDER_BLUE,
  },
  secondary: {
    main: COLORS.ORANGE,
  },
  info: {
    main: COLORS.LIGHT_BLUE,
  },
  custom: {
    main: COLORS.BLUE,
  },
  alertinfo: {
    main: COLORS.BLUE,
    light: COLORS.BLUE,
    dark: COLORS.BLUE,
    contrastText: "#242105",
  },
};

export const PAS_COLORS: PaletteOptions = {
  primary: {
    main: COLORS.BLUE,
  },
  secondary: {
    main: COLORS.PAS_ORANGE,
  },
  info: {
    main: COLORS.LIGHT_BLUE,
  },
  custom: {
    main: COLORS.POWDER_BLUE,
  },
  alertinfo: {
    main: COLORS.POWDER_BLUE,
    light: COLORS.POWDER_BLUE,
    dark: COLORS.POWDER_BLUE,
    contrastText: "#242105",
  },
};

export const OVERRIDE_SELECTORS: Record<OrganizationKey, OverrideSelectors> = {
  LKC: {
    footerText: (p) => p.text.secondary,
    participantSelectionSelectedBackground: (p) => p.primary.light,
  },
  PAS: {
    footerText: (p) => p.primary.contrastText,
    participantSelectionSelectedBackground: (p) => p.custom.light,
  },
};

export const UNIT_USAGE_SELECTORS: Record<OrganizationKey, UnitUsageSelectors> = {
  LKC: {
    [UnitUsageRange.Under60]: (p) => p.info.main,
    [UnitUsageRange.Range60to80]: (p) => p.primary.light,
    [UnitUsageRange.Range80to100]: (p) => lighten(p.custom.main, 0.1),
    [UnitUsageRange.Over100]: (p) => darken(p.custom.main, 0.3),
  },
  PAS: {
    [UnitUsageRange.Under60]: (p) => p.info.main,
    [UnitUsageRange.Range60to80]: (p) => p.custom.light,
    [UnitUsageRange.Range80to100]: (p) => lighten(p.primary.main, 0.1),
    [UnitUsageRange.Over100]: (p) => darken(p.primary.main, 0.3),
  },
};
